import { render, staticRenderFns } from "./ManageModules.vue?vue&type=template&id=4c165a15&"
import script from "./ManageModules.vue?vue&type=script&lang=js&"
export * from "./ManageModules.vue?vue&type=script&lang=js&"
import style0 from "./ManageModules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports